import Match from './match';
import './match.scss';

export default Match;